export default "__VITE_ASSET__vx1VE29s__"